import Base from 'app/models/base';

export default Base.extend({ });



// WEBPACK FOOTER //
// ./app/models/rate.js